module.exports = __webpack_public_path__ + "img/mono-rounded.0dc59a18.svg";